import { genStyleHook } from '../../tools/style';

export default genStyleHook('exception', (token) => {
  const { componentCls } = token;

  return {
    [componentCls]: {
      display: 'flex',
      alignItems: 'center',
      height: '80%',
      minHeight: '500px',
      padding: `${token.paddingLG * 2}px ${token.paddingXL}px`,

      [`${componentCls}-imgBlock`]: {
        flex: '0 0 62.5%',
        width: '62.5%',
        paddingRight: '152px',
        zoom: 1,
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'flex-end',
      },

      [`${componentCls}-imgEle`]: {
        height: '360px',
        width: '100%',
        maxWidth: '430px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
        backgroundSize: 'contain',
      },

      [`${componentCls}-content`]: {
        flex: 'auto',

        h1: {
          color: '#434e59',
          fontSize: '32px',
          fontWeight: 600,
          lineHeight: 1.2,
          marginTop: 0,
          marginBottom: '16px',
        },

        [`${componentCls}-desc`]: {
          color: token.colorTextDescription,
          fontSize: '16px',
          marginBottom: '16px',
        },

        [`${componentCls}-actions`]: {
          'button:not(:last-child)': {
            marginRight: '8px',
          },
        },
      },

      [`@media screen and (max-width: ${token.screenXL}px)`]: {
        [`${componentCls}-imgBlock`]: {
          paddingRight: '88px',
        },
      },

      [`@media screen and (max-width: ${token.screenSM}px)`]: {
        display: 'block',
        textAlign: 'center',
        [`${componentCls}-imgBlock`]: {
          paddingRight: 0,
          margin: '0 auto 24px',
        },
      },

      [`@media screen and (max-width: ${token.screenXS}px)`]: {
        [`${componentCls}-imgBlock`]: {
          marginBottom: '-24px',
          overflow: 'hidden',
        },
      },
    },
  };
});
